import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Bar } from 'react-chartjs-2';
import Table from 'react-bootstrap/Table';
import * as moment from 'moment';
import { Image } from 'react-bootstrap';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { getCountAdvertisingAnalysisByConditionAction } from '../../store/reducers/advertisingAnalysis';
import { objectReportAdvertisingAnalysis, reportAdvertisingAnalysis, rangeDate } from '../../utils/define';
import { dateTimeToStringRequest, exportExcel } from '../../utils/helper';
import { BaseGatewayImage } from '../../utils/apiUrl';

const RepostAdvertising = () => {
    const dispatch = useDispatch();
    const listCountAdversingClick = useSelector(
        (state) => state.advertisingAnalysis.listCountAdversingClick
    );
    const timeCurentDay = moment().subtract(6, 'days');
    timeCurentDay.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });

    const [valueReportType, setValueReportType] = useState(
        objectReportAdvertisingAnalysis[0].value
    );

    const [dates, setDates] = useState({
        startDate: timeCurentDay,
        endDate: moment()
    });
    const [LabelsChart, setLabelsChart] = useState([]);
    const [DataChart, setDataChart] = useState([]);
    const [Total, setToTal] = useState([]);

    useEffect(() => {
        const model = {
            ReportType: valueReportType,
            fromDate: dates.startDate
                ? dateTimeToStringRequest(dates.startDate.toDate())
                : '',
            toDate: dates.endDate
                ? dateTimeToStringRequest(dates.endDate.toDate())
                : ''
        };
        dispatch(getCountAdvertisingAnalysisByConditionAction(model));
    }, [dates, valueReportType]);

    useEffect(() => {
        let labelsChart = [];
        let dataChart = [];
        let total = 0;
        if (listCountAdversingClick && listCountAdversingClick.length > 0) {
            listCountAdversingClick.forEach((item) => {
                if (
                    valueReportType === reportAdvertisingAnalysis.ByDate
                ) {
                    labelsChart = labelsChart.concat(
                        moment(item.title).format('DD/MM/YYYY')
                    );
                } else if (
                    valueReportType === reportAdvertisingAnalysis.ByImageThumb
                ) {
                    labelsChart = labelsChart.concat(BaseGatewayImage + item.title);
                }
                else {
                    labelsChart = labelsChart.concat(item.title);
                }
                dataChart = dataChart.concat(item.total);
                total += item.total;
            });
        }
        setDataChart(dataChart);
        setLabelsChart(labelsChart);
        setToTal(total);
    }, [listCountAdversingClick]);

    const getTitle = () => {
        switch (valueReportType) {
            case reportAdvertisingAnalysis.ByCategoryId:
                return 'Danh mục';
            case reportAdvertisingAnalysis.ByDate:
                return 'Ngày';
            case reportAdvertisingAnalysis.ByImageThumb:
                return 'Link quảng cáo';
            default:
                break;
        }
        return null;
    };

    const onChangeRepostType = (e) => {
        setValueReportType(e.target.value);
    };

    const handleApply = (event, picker) => {
        setDates({
            startDate: picker.startDate,
            endDate: picker.endDate
        });
        picker.element.val(
            `${picker.startDate.format('DD/MM/YYYY')} - ${picker.endDate.format(
                'DD/MM/YYYY'
            )}`
        );
    };
    const handleCancel = (event, picker) => {
        picker.element.val('');
    };
    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header">
                            <h2 className="card-title"> Thống kê quảng cáo</h2>
                        </div>
                        <div className="card-body">
                            <div className="d-flex justify-content-between">
                                <form className="form-inline">
                                    <label htmlFor="exampleEmail2" className>
                                        Lọc theo :
                                    </label>
                                    <select
                                        className="form-control"
                                        value={valueReportType}
                                        onChange={(e) => onChangeRepostType(e)}
                                    >
                                        {objectReportAdvertisingAnalysis.map((item, key) => (
                                            <option
                                                key={Number(key)}
                                                value={item.value}
                                            >
                                                {item.text}
                                            </option>
                                        ))}
                                    </select>
                                    <label
                                        htmlFor="exampleEmail2"
                                        className="ml-3 mr-2"
                                    >
                                        Lọc theo thời gian :
                                    </label>
                                    <DateRangePicker
                                        onApply={handleApply}
                                        onCancel={handleCancel}
                                        initialSettings={{
                                            autoUpdateInput: false,
                                            locale: {
                                                cancelLabel: 'Clear'
                                            },
                                            ranges: rangeDate,
                                            startDate: moment(
                                                dates.startDate
                                            ).format('MM/DD/YYYY'),
                                            endDate: moment(
                                                dates.endDate
                                            ).format('MM/DD/YYYY')
                                        }}
                                    >
                                        <input
                                            onChange={(e) => {
                                                if (
                                                    e.target.value.length === 0
                                                ) {
                                                    setDates({
                                                        startDate: null,
                                                        endDate: null
                                                    });
                                                }
                                            }}
                                            defaultValue={`${moment(
                                                dates.startDate
                                            ).format('DD/MM/YYYY')} - ${moment(
                                                dates.endDate
                                            ).format('DD/MM/YYYY')}`}
                                            type="text"
                                            className="form-control"
                                        />
                                    </DateRangePicker>
                                </form>
                                <NavLink
                                    className="nav-link-reject nav-link"
                                    to
                                    onClick={() => exportExcel(`baocao_${valueReportType.toLowerCase()}_${Date.now()}`)}
                                >
                                    <button
                                        type="button"
                                        className="btn btn-info"
                                    >
                                        Xuất file Excel
                                    </button>
                                </NavLink>
                            </div>
                            <div
                                id="example2_wrapper"
                                className="dataTables_wrapper dt-bootstrap4"
                            >
                                {/* <div className="row">
                                    <div className="col-sm-6">
                                        <Bar
                                            data={{
                                                labels: LabelsChart,
                                                datasets: [
                                                    {
                                                        backgroundColor: [
                                                            '#DB4437'
                                                        ],
                                                        data: DataChart,
                                                        label: 'Tống số truy cập',
                                                    }
                                                ]
                                            }}
                                            options={{
                                                legend: { display: false },
                                                title: {
                                                    display: true,
                                                    text: 'Predicted world population (millions) in 2050'
                                                }
                                            }}
                                        />
                                    </div>
                                </div> */}
                                <div className="row">
                                    <div className="col-sm-12">
                                        <Table
                                            id="table-to-xls"
                                            striped
                                            bordered
                                            hover
                                        >
                                            <thead>
                                                <tr role="row">
                                                    <th className="sorting">
                                                        {getTitle()}
                                                    </th>
                                                    {
                                                        valueReportType ===
                                                            reportAdvertisingAnalysis.ByImageThumb ?
                                                            <th>Ảnh</th> : null
                                                    }
                                                    <th className="sorting">
                                                        Tổng số truy cập
                                                    </th>
                                                </tr>
                                            </thead>
                                            {listCountAdversingClick.length >
                                                0 ? (
                                                <tbody>
                                                    {listCountAdversingClick.map(
                                                        (item, index) => (
                                                            <tr
                                                                key={Number(
                                                                    index
                                                                )}
                                                                className="odd"
                                                            >
                                                                <td>
                                                                    {valueReportType ===
                                                                        reportAdvertisingAnalysis.ByDate
                                                                        ? moment(
                                                                            item.title
                                                                        ).format(
                                                                            'DD/MM/YYYY'
                                                                        )
                                                                        : valueReportType ===
                                                                            reportAdvertisingAnalysis.ByImageThumb ?
                                                                            <a href={BaseGatewayImage + item.title}>
                                                                                {BaseGatewayImage + item.title}
                                                                            </a>

                                                                            :
                                                                            item.title
                                                                    }
                                                                </td>
                                                                {
                                                                    valueReportType ===
                                                                        reportAdvertisingAnalysis.ByImageThumb ?
                                                                        <td>
                                                                            <Image
                                                                                src={` ${BaseGatewayImage}${item.title}`}
                                                                                rounded
                                                                            />
                                                                        </td> : null
                                                                }
                                                                <td>
                                                                    {item.total}
                                                                </td>
                                                            </tr>
                                                        )
                                                    )}
                                                    {listCountAdversingClick.length >
                                                        0 ? (
                                                        <tr>
                                                            <td>Tổng số truy cập</td>
                                                            {
                                                                valueReportType ===
                                                                    reportAdvertisingAnalysis.ByImageThumb ?
                                                                    <td>
                                                                        Ảnh
                                                                    </td> : null
                                                            }
                                                            <td>{Total}</td>
                                                        </tr>
                                                    ) : null}
                                                </tbody>
                                            ) : (
                                                <tbody>
                                                    <tr className="txt-center">
                                                        <td colSpan="12">
                                                            Không có dữ liệu
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            )}
                                        </Table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default RepostAdvertising;
